import api from '@/api';

const resource = 'merenda/cardapio-escola';

export default {
  criarCardapioEscola( data ) {
    return api.post( `${resource}`, data );
  },

  editarCardapioEscola( data ) {
    return api.put( `${resource}/${data.identificadorcardapioescola}`, data);
  },

  deletarCardapioEscola( id ) {
    return api.delete(`${resource}/${id}`);
  },

  buscarCardapioEscola() {
    return api.get( `${resource}` );
  },

  buscarCardapiosPorEscola(anoletivo, cdtipesc, cdescola) {
    return api.get( `${resource}/cardapios-por-escola?anoletivo=${anoletivo}&cdtipesc=${cdtipesc}&cdescola=${cdescola}` );
  },

  buscarCardapiosPorUnidadeEscolar(anoletivo, identificadorescolalocalexterno) {
    return api.get( `${resource}/cardapios-por-unidade-escolar?anoletivo=${anoletivo}&identificadorescolalocalexterno=${identificadorescolalocalexterno}` );
  },

  recebeMerenda() {
    return api.get(`merenda/recebe-merenda/`);
  },
};
